import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as ObleaConfiguracionService from '../../services/obleaConfiguracion.service';

import type { RootState } from '../store';

type Entity = Awaited<ReturnType<typeof ObleaConfiguracionService.getObleaConfiguracion>>;

export const fetchObleaConfiguracion = createAsyncThunk<Entity>(
  'obleaConfiguracion/fetch',
  (_params, api) => {
    const { obleaConfiguracion } = api.getState() as RootState;
    if (obleaConfiguracion.entity) return Promise.resolve(obleaConfiguracion.entity);
    return ObleaConfiguracionService.getObleaConfiguracion();
  }
);

interface ObleaConfiguracionState {
  loading: boolean;
  entity: Entity | null;
}

const initialState: ObleaConfiguracionState = { loading: false, entity: null };

const obleaConfiguracionSlice = createSlice({
  name: 'obleaConfiguracion',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchObleaConfiguracion.fulfilled, (state, action) => {
      state.entity = action.payload;
      state.loading = false;
    });

    builder.addCase(fetchObleaConfiguracion.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(fetchObleaConfiguracion.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const obleaConfiguracionActions = {
  ...obleaConfiguracionSlice.actions,
  fetchObleaConfiguracion
};

export default obleaConfiguracionSlice.reducer;
